import { AddressInformation } from './address-detail-info';
import { Autoship } from './autoship';
import { SponsorInformation } from './sponsor-information';
import { FBOBusinessEntity } from './fbo-business-entity';
import { RetailSubscription } from './retail-subscription';

export class ProfileInformation {
    id: number;
    fboId: string;
    userName: string;
    name: string;
    firstName: string;
    lastName: string;
    middleName: string;
    memberLevel: string;
    level: string;
    memberLevelId: Number;
    homeCountryId: Number;
    memberId: number;
    enrollmentDate: Date;
    firstPurchaseDate: Date;
    preferredLanguage: string;
    governmentId: string;
    sponsorDetails: SponsorInformation;
    address: AddressInformation;
    storeEligibility: any;
    profileImageURL: string;
    emailId: string;
    email: string;
    homeCountryCode: string;
    homePhoneNumber: string;
    contactNumber:string
    mobile: string;
    businessEntities: FBOBusinessEntity[];
    autoShipItems: Autoship[];
    paymentCardURL: string;
    cardName: string;
    cardNumber: string;
    expireDate: string;
    status: string;
    birthDate: Date;
    spouse: string;
    hasFLP360Account: boolean;
    hasDiscoverApp: boolean;
    firstActiveUplineManager: SponsorInformation;
    hasAutoShip: boolean;
    operatingCountry: string;
    wholesaleQualified: any;
    spouseFullName: any;
    memberType: string;
    governmentIdentificationType: string;
    memberTypeId: number;
    memberTitleId: number;
    governmentIDType: number;
    foreignFbo: boolean;
    memberPreference: string;
    amazonSubscription?: string;
    distributorId?: string;
    displayName?: string;
    optinDate?: Date;
    operatingCountryCode?: string;
    memberTitle?:string;
    memberStatus?:string;
    storeId?:number;
    memberRankLevels?: Array<any>;
    accountLevelId?: number;
    accountLevelTitle?: string;
    wholesaleQualifiedCheck?: boolean;
    memberOptin?;boolean;
    retailSubscriptionModel? : RetailSubscription;
    preferenceValue?:number;
    displayMiddleName?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/customerservice/interface/profile-info.ts